import { render, staticRenderFns } from "./ProductDetailPage.vue?vue&type=template&id=03a6807e&scoped=true&"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailPage.vue?vue&type=style&index=0&id=03a6807e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a6807e",
  null
  
)

export default component.exports